"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canCountDimension = canCountDimension;
exports.default = exports.checkMeasurement = void 0;
exports.getMeasurementDimension = getMeasurementDimension;
exports.getMeasurementItem = getMeasurementItem;
exports.getMeasurementMetric = getMeasurementMetric;
exports.getMeasurementSync = getMeasurementSync;
exports.isQueryableMetric = isQueryableMetric;
exports.measurements = void 0;
var _synthMeasurements = require("@kentik/ui-shared/dictionary/measurements/synthMeasurements");
var _commonMetrics = require("@kentik/ui-shared/query/measurements/commonMetrics");
var _commonDimensions = require("./measurements/commonDimensions");
var _cloudDimensions = require("./measurements/cloudDimensions");
var _rdnsDimensions = require("./measurements/rdnsDimensions");
var _cloudMetrics = _interopRequireDefault(require("./measurements/cloudMetrics"));
var _enumUtils = require("./enumUtils");
const measurements = exports.measurements = [{
  measurement: '/traffic',
  displayName: 'Traffic',
  storage: {
    Metrics: _commonMetrics.commonTrafficMetrics,
    Dimensions: {
      ..._commonDimensions.commonTrafficDimensions,
      ..._cloudDimensions.awsDimensions,
      ..._cloudDimensions.azureDimensions,
      ..._rdnsDimensions.rdnsDimensions
    },
    SupportsFastData: true
  }
}, {
  measurement: '/bgp',
  displayName: 'BGP',
  storage: {
    Metrics: {
      Announcements: {
        Label: 'Announcements',
        Type: 'int',
        Column: 'INT64_00'
      },
      Updates: {
        Label: 'Updates',
        Type: 'int',
        Column: 'INT64_13'
      },
      Withdraws: {
        Label: 'Withdraws',
        Type: 'int',
        Column: 'INT64_14'
      },
      'AS Path Hop Number: L0': {
        Label: 'AS Path Hop Number: L0',
        Type: 'int',
        Column: 'INT64_02'
      },
      'AS Path Hop Number: L1': {
        Label: 'AS Path Hop Number: L1',
        Type: 'int',
        Column: 'INT64_03'
      },
      'AS Path Hop Number: L2': {
        Label: 'AS Path Hop Number: L2',
        Type: 'int',
        Column: 'INT64_04'
      },
      'AS Path Hop Number: L3': {
        Label: 'AS Path Hop Number: L3',
        Type: 'int',
        Column: 'INT64_05'
      },
      'AS Path Hop Number: R0 (Origin ASN)': {
        Label: 'AS Path Hop Number: R0 (Origin ASN)',
        Type: 'int',
        Column: 'INT64_06'
      },
      'AS Path Hop Number: R1': {
        Label: 'AS Path Hop Number: R1',
        Type: 'int',
        Column: 'INT64_07'
      },
      'AS Path Hop Number: R2': {
        Label: 'AS Path Hop Number: R2',
        Type: 'int',
        Column: 'INT64_08'
      },
      'AS Path Hop Number: R3': {
        Label: 'AS Path Hop Number: R3',
        Type: 'int',
        Column: 'INT64_09'
      },
      'RIB Entries': {
        Label: 'RIB Entries',
        Type: 'int',
        Column: 'INT64_10'
      },
      'RIB Prefixes': {
        Label: 'RIB Prefixes',
        Type: 'int',
        Column: 'INT64_11'
      },
      'State Syncs': {
        Label: 'State Syncs',
        Type: 'int',
        Column: 'INT64_12'
      }
    },
    Dimensions: {
      device_ip: {
        Type: 'string',
        Label: 'Device IP',
        Column: 'STR00'
      },
      description: {
        Type: 'string',
        Label: 'Description',
        Column: 'STR01'
      },
      device_name: {
        Type: 'string',
        Label: 'Device Name',
        Column: 'STR03'
      }
    }
  }
}, {
  measurement: '/events',
  displayName: 'SNMP Events',
  storage: {
    Metrics: {
      'snmp-trap-count': {
        Label: 'SNMP Trap Count',
        Type: 'int',
        Column: 'INT64_00'
      },
      'alert-count': {
        Label: 'Alert Count',
        Type: 'int',
        Column: 'INT64_00'
      }
    },
    Dimensions: {
      ..._commonDimensions.commonTrafficDimensions
    }
  }
},
// Synthetics Health measurements - imported from dictionary
..._synthMeasurements.syntheticsHealthMeasurements, {
  measurement: '/cost',
  displayName: 'Cost',
  storage: {
    Metrics: {
      'Cost per Mbit': {
        Type: 'int',
        Label: 'Cost per Mbit',
        Column: 'INT64_00'
      },
      'Total Cost': {
        Type: 'int',
        Label: 'Total Cost',
        Column: 'INT64_01'
      }
    },
    Dimensions: {
      'cost-group': {
        Type: 'string',
        Label: 'Cost Group',
        Column: 'STR00'
      },
      ..._commonDimensions.commonTrafficDimensions
    }
  }
}, ..._cloudMetrics.default];
const checkMeasurement = exports.checkMeasurement = {
  isTraffic: m => m?.startsWith('/traffic') ?? false,
  isNms: m => m?.startsWith('/metrics') ?? false,
  isSynth: m => m?.startsWith('/synthetics') ?? false,
  isEvents: m => m?.startsWith('/events') ?? false,
  isTrafficChild: m => m?.startsWith('/traffic/') ?? false,
  isNmsChild: m => m?.startsWith('/metrics/') ?? false,
  isSynthChild: m => m?.startsWith('/synthetics/') ?? false,
  isTrafficRoot: m => m === '/traffic',
  isNmsRoot: m => m === '/metrics',
  isSynthRoot: m => m === '/synthetics',
  isEventsChild: m => m?.startsWith('/events/') ?? false,
  isEventsRoot: m => m === '/events'
};
function canCountDimension(name, dimension) {
  const column = dimension.Column ?? name;
  const queryColumn = dimension.QueryColumn ?? column;
  return !dimension.FilterOnly && (!column.startsWith('i_') || !queryColumn.startsWith('i_'));
}
function getMeasurementSync(measurementName, fetchedMetrics) {
  let allMeasurements = measurements;
  if (fetchedMetrics) {
    allMeasurements = fetchedMetrics;
  }
  const match = allMeasurements.find(m => m.measurement === measurementName) || null;
  if (match) {
    return match;
  }
  if (checkMeasurement.isTrafficChild(measurementName)) {
    return allMeasurements.find(m => checkMeasurement.isTrafficRoot(m.measurement)) || null;
  }
  return null;
}
function getMeasurementItemInternal(measurementObj, type, name, allMeasurements) {
  const typeKey = type === 'metric' ? 'Metrics' : 'Dimensions';

  // First, try to find the item in the measurement's own storage
  const item = measurementObj.storage[typeKey]?.[name];
  if (item) {
    return item;
  }

  // If not found and this is a traffic child, look for shared items in /traffic
  if (checkMeasurement.isTrafficChild(measurementObj.measurement)) {
    const trafficMeasurement = allMeasurements.find(m => checkMeasurement.isTrafficRoot(m.measurement));
    if (trafficMeasurement?.storage) {
      const sharedItem = trafficMeasurement.storage[typeKey]?.[name];
      if (sharedItem?.Shared) {
        return sharedItem;
      }
    }
  }

  // If not found and this is a traffic root, look in traffic children
  if (checkMeasurement.isTrafficRoot(measurementObj.measurement)) {
    for (const m of allMeasurements) {
      if (checkMeasurement.isTrafficChild(m.measurement)) {
        const childItem = m.storage[typeKey]?.[name];
        if (childItem) {
          return childItem;
        }
      }
    }
  }
  return null;
}
function getMeasurementItem(measurement, type, name, allMeasurements = measurements) {
  const measurementObj = typeof measurement === 'string' ? allMeasurements.find(m => m.measurement === measurement) : measurement;
  if (!measurementObj) {
    return null;
  }
  const item = getMeasurementItemInternal(measurementObj, type, name, allMeasurements);
  if (item) {
    return item;
  }

  // If this is a dimension, check for enum metrics
  if (type === 'dimension') {
    const metric = getMeasurementItemInternal(measurementObj, 'metric', name, allMeasurements);
    if ((0, _enumUtils.isEnumItem)(metric)) {
      return metric;
    }
  }

  // If this is a metric, check for dimensions (for count aggregates)
  if (type === 'metric') {
    const dimension = getMeasurementItemInternal(measurementObj, 'dimension', name, allMeasurements);
    if (dimension && canCountDimension(name, dimension)) {
      return {
        ...dimension,
        Label: `${dimension.Label || name} Count`,
        Unit: 'integer',
        Window: 'count'
      };
    }
  }
  return null;
}
function getMeasurementMetric(measurement, name) {
  return getMeasurementItem(measurement, 'metric', name);
}
function getMeasurementDimension(measurement, name) {
  return getMeasurementItem(measurement, 'dimension', name);
}

/** Returns true if the metric item has a physical storage column that can be queried. */
function isQueryableMetric(metric) {
  return !!(metric?.Column || metric?.QueryColumn);
}
var _default = exports.default = measurements;